export default "__VITE_ASSET__6VlAVTWM__"